import { Controller } from "@hotwired/stimulus"

// Handles showing/hiding meeting-specific fields based on project type selection
// Also handles Linear Issues project type warnings
export default class extends Controller {
  static targets = ["meetingFields", "select", "linearWarning"]
  static values = {
    linearIntegrationActive: Boolean
  }

  connect() {
    console.log("Project type controller connected")
    // Check initial state on page load
    this.toggleMeetingFields()
    this.toggleLinearWarning()
  }

  toggleLinearWarning() {
    if (!this.hasSelectTarget) return

    const projectType = this.selectTarget.value
    const warningElement = document.getElementById('linear-integration-warning')

    if (!warningElement) return

    if (projectType === 'linear_issues' && !this.linearIntegrationActiveValue) {
      warningElement.classList.remove('hidden')
    } else {
      warningElement.classList.add('hidden')
    }
  }

  toggleMeetingFields() {
    // Get the project type value from the select element
    const selectElement = this.hasSelectTarget ? this.selectTarget : this.element
    const projectType = selectElement.value
    const meetingFields = document.getElementById('meeting-fields')
    
    console.log("Toggle meeting fields - project type:", projectType)
    
    if (!meetingFields) return
    
    if (projectType === 'meeting') {
      console.log("Showing meeting fields")
      // Show meeting fields
      meetingFields.classList.remove('hidden')
      meetingFields.style.display = 'block'
      
      // Make meeting fields required
      meetingFields.querySelectorAll('[data-meeting-field]').forEach(field => {
        if (field.name.includes('meeting_date') || field.name.includes('meeting_type')) {
          field.required = true
        }
      })
      
      // Update help text
      this.updateHelpText(true)
    } else {
      console.log("Hiding meeting fields")
      // Hide meeting fields
      meetingFields.classList.add('hidden')
      meetingFields.style.display = 'none'
      
      // Remove required from meeting fields
      meetingFields.querySelectorAll('[data-meeting-field]').forEach(field => {
        field.required = false
      })
      
      // Update help text
      this.updateHelpText(false)
    }

    // Also check Linear integration warning
    this.toggleLinearWarning()
  }

  updateHelpText(isMeeting) {
    const helpSection = document.querySelector('.bg-blue-50')
    if (!helpSection) return
    
    const helpList = helpSection.querySelector('ul')
    if (!helpList) return
    
    if (isMeeting) {
      helpList.innerHTML = `
        <li class="flex items-start gap-2">
          <span class="text-primary">1.</span>
          <span>Upload your meeting transcript or notes</span>
        </li>
        <li class="flex items-start gap-2">
          <span class="text-primary">2.</span>
          <span>Our AI will extract action items and decisions</span>
        </li>
        <li class="flex items-start gap-2">
          <span class="text-primary">3.</span>
          <span>Convert action items into user stories and development tasks</span>
        </li>
        <li class="flex items-start gap-2">
          <span class="text-primary">4.</span>
          <span>Generate Claude Code prompts for immediate implementation</span>
        </li>
      `
    } else {
      helpList.innerHTML = `
        <li class="flex items-start gap-2">
          <span class="text-primary">1.</span>
          <span>You'll answer 10 detailed questions about your app idea</span>
        </li>
        <li class="flex items-start gap-2">
          <span class="text-primary">2.</span>
          <span>Our AI will analyze your responses and generate a comprehensive PRD</span>
        </li>
        <li class="flex items-start gap-2">
          <span class="text-primary">3.</span>
          <span>You'll receive task lists and Claude Code prompts to start building</span>
        </li>
      `
    }
  }
}